import { TriangleAlert } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const WarningIcon = createLucideIcon(TriangleAlert);
